import * as React from "react"
import { useEffect } from "react"
import { Grid } from "@mui/material"
import { disabledAfter } from "@ui-seeker/core"

import { STOCK_ROUTES, YESTERDAY_DATE } from "@constants"
import { isSystemBusy } from "@signals"
import PageWrapper from "Pages/@PageWrapper"
import { TourProvider, TourTarget } from "@tour"
import StockShareTableSkuDetails from "./@components/SkuDetailsTable"
import StockChangesFilters from "./Filters"
import { resetStockShare, stockShareIsEmpty } from "./signals"
import StockShareTable from "./Table"


export default function StockSharePage() {

    useEffect(() => {
        return () => resetStockShare()
    },[])

    return <PageWrapper
        isEmpty={stockShareIsEmpty.value}
        tourPageKey="share"
        head={`DIP Insight | ${STOCK_ROUTES.STOCK_SHARE_TITLE}`}
        title={STOCK_ROUTES.STOCK_SHARE_TITLE}
        subtitle={STOCK_ROUTES.STOCK_SHARE_SUBTITLE}
        filters={<StockChangesFilters />}
        hasErrors={isSystemBusy.value}
        actionProps={{
            dateRangeProps: { shouldDisableDate: disabledAfter(YESTERDAY_DATE) }
        }
}
    >
        <Grid container spacing={4} sx={{ mt: 1 }}>
            <Grid item xs={12} sx={{ position: "relative" }}>
                <TourTarget name="share-table" height={350} />
                <StockShareTable />
            </Grid>

            <Grid item xs={12} data-tour="share-sku-details">
                <StockShareTableSkuDetails />
            </Grid>
        </Grid>
    </PageWrapper>
}
